import "../../styles/index.css";
import "./Montagem.css";
import Location from "../../components/Location/Location";
import BotaoAdicionar from "../../components/Buttons/BotaoAdicionar/BotaoAdicionar";
import ModalEscolherPeça from "../../components/Modals/ModalEscolherPeça/ModalEscolherPeça";
import ImagemExemplo from "../../assets/img/Imagem Exemplo.png";
import SaveIcon from "../../assets/icons/Save Icon.svg";
import ShareIcon from "../../assets/icons/Share Icon.svg";
import ModalSalvarSetup from "../../components/Modals/ModalSalvarSetup/ModalSalvarSetup";
import { apiCategorias } from "../../api/api";
import CardMontagem from "../../components/Cards/CardMontagem/CardMontagem";
import { useState, useEffect } from "react";
import { categoryFromDatabase } from "../../utils/categoryFromDatabase";
import { useSearchParams } from "react-router-dom";
import $ from "jquery";
import { ToastContainer, toast } from 'react-toastify';
import { formataPreço } from "../../utils/preços";
import 'react-toastify/dist/ReactToastify.css';

function Montagem({ isLogged, email }) {

	const [searchParams, setSearchParams] = useSearchParams();

	const [preçoTotal, setPreçoTotal] = useState("0,00");
	const [peçaDesejada, setPeçaDesejada] = useState("");
	const [wattsProdutos, setWattsProdutos] = useState({});
	const [wattsRecomendado, setWattsRecomendado] = useState(100);

	const [idsProdutosEscolhidos, setIdsProdutosEscolhidos] = useState({});

	const [produtosEscolhidos, setProdutosEscolhidos] = useState({
		Processador: null,
		Cooler: null,
		"Placa-Mãe": null,
		"Memória RAM": null,
		"Placa de Vídeo": null,
		Armazenamento: null,
		Fonte: null,
		Gabinete: null,
	});

	useEffect(() => {
		reloadPreviousStateFromUrl();
	}, []);

	useEffect(() => {
		let wattsRecomendadoAcumulador = 100

		Object.keys(wattsProdutos).forEach((key) => {
			let watts = parseInt(wattsProdutos[key].split(' ')[0])

			wattsRecomendadoAcumulador += watts
		})

		setWattsRecomendado(wattsRecomendadoAcumulador)
	}, [wattsProdutos]);

	useEffect(() => {
		const idsProdutosEscolhidosAux = { ...idsProdutosEscolhidos };
		const keys = Object.keys(idsProdutosEscolhidosAux)

		keys.forEach((key) => {
			const id = idsProdutosEscolhidosAux[key];

			if (id === undefined) return

			idsProdutosEscolhidosAux[categoryFromDatabase[key]] = id
			delete idsProdutosEscolhidosAux[key]
		});

		setSearchParams(idsProdutosEscolhidosAux);
	}, [idsProdutosEscolhidos]);

	useEffect(() => {
		atualizarPrecoTotal();
	}, [produtosEscolhidos]);

	function atualizarPrecoTotal() {

		if (!produtosEscolhidos || produtosEscolhidos === undefined || produtosEscolhidos === null) {
			return;
		}

		console.log("produtosEscolhidos", produtosEscolhidos);

		const preçoAtual = Object.values(produtosEscolhidos).reduce(
			(precoAcumulado, peça) => {
				if (peça) {
					return precoAcumulado + Number(peça.preço);
				}
				return precoAcumulado;
			},

			0
		);

		setPreçoTotal(preçoAtual.toFixed(2).replace(".", ","));
	}

	function adicionarWattsRecomendado(categoria, produto) {
		const wattsProdutosAux = wattsProdutos

		console.log("categoria", categoria)

		if (Object.keys(produto).includes("TDP")) {
			wattsProdutosAux[categoria] = produto["TDP"]
		}

		if (Object.keys(produto).includes("tdp")) {
			wattsProdutosAux[categoria] = produto["tdp"]
		}

		setWattsProdutos({ ...wattsProdutosAux })
	}

	const reloadPreviousStateFromUrl = () => {
		const idsProdutosEscolhidosAux = {};
		const produtosEscolhidosAux = { ...produtosEscolhidos };
		const categorias = Object.keys(produtosEscolhidosAux);

		categorias.forEach(async (categoria) => {
			const idProduto = searchParams.get(categoria);

			if (idProduto) {
				idsProdutosEscolhidosAux[categoryFromDatabase[categoria]] = idProduto;

				await apiCategorias
					.listaProdutoConfigs(categoria, idProduto)
					.then((response) => {
						const lojas = response.stores;

						const preços = [];

						lojas.forEach((loja) => {
							if (loja.stock_available === true) {
								preços.push(parseFloat(loja.spot_price));
							}
						});

						const preço = Math.min(...preços);

						const foto =
							response["images"].length !== 0
								? response["images"][0]
								: ImagemExemplo;

						produtosEscolhidosAux[categoria] = {
							key: response["id"],
							imagem: foto,
							nome: response["name"],
							preço: preço.toString(),
							categoria: categoria,
							id: response["id"],
							onClick: () => onClickProdutoRemovido(categoria),
						};

						setProdutosEscolhidos({ ...produtosEscolhidosAux });

						setIdsProdutosEscolhidos({
							...idsProdutosEscolhidosAux,
							[categoryFromDatabase[categoria]]: idProduto,
						});

						adicionarWattsRecomendado(categoria, response)
					});
			}
		});
	};

	const onClickProdutoSelecionado = async (categoria, id) => {
		const aux = { ...produtosEscolhidos };

		await apiCategorias.listaProdutoConfigs(categoria, id).then((response) => {
			console.log(response);

			const lojas = response.stores;

			const preços = [];

			lojas.forEach((loja) => {
				if (loja.stock_available === true) {
					preços.push(parseFloat(loja.spot_price));
				}
			});

			const preço = Math.min(...preços);

			const foto =
				response["images"].length !== 0 ? response["images"][0] : ImagemExemplo;

			aux[categoria] = {
				key: response["id"],
				imagem: foto,
				nome: response["name"],
				preço: preço.toString(),
				categoria: categoria,
				id: response["id"],
				onClick: () => onClickProdutoRemovido(categoria),
			};

			setProdutosEscolhidos(aux);

			const idsProdutosEscolhidosAux = idsProdutosEscolhidos;
			idsProdutosEscolhidosAux[categoryFromDatabase[categoria]] =
				response["id"];

			setIdsProdutosEscolhidos({ ...idsProdutosEscolhidosAux });

			console.log("adicionado", idsProdutosEscolhidos);

			Object.keys(idsProdutosEscolhidosAux).forEach((key) => {
				idsProdutosEscolhidosAux[categoryFromDatabase[key]] =
					idsProdutosEscolhidosAux[key];

				delete idsProdutosEscolhidosAux[key];
			});

			setSearchParams({ ...idsProdutosEscolhidosAux });

			adicionarWattsRecomendado(categoria, response)
		});
	};

	const onClickProdutoRemovido = (categoria) => {

		setProdutosEscolhidos((previousState) => ({
			...previousState,
			[categoria]: null,
		}));

		setIdsProdutosEscolhidos((previousState) => {
			const novosIdsProdutos = { ...previousState };
			delete novosIdsProdutos[categoryFromDatabase[categoria]];

			return novosIdsProdutos;
		});

		setWattsProdutos((previousState) => {
			const previousStateAux = { ...previousState }
			delete previousStateAux[categoria]

			return previousStateAux
		})
	}

	const onClickLevaProLogin = () => {
		$('#botaoLogarComGoogle').click();
	}

	const onClickCompartilharSetup = async () => {

		if (preçoTotal !== '0,00') {

			if (navigator.share) {
				navigator.share({
					title: "OnPrice", text: "Veja a minha montagem!", url: window.location.href
				})
			} else {
				await navigator.clipboard.writeText(window.location.href);
				toast("Link Copiado com Sucesso.");
			}

		} else {
			toast("Seu Setup está vazio.");
		}

	}

	return (
		<>
			<ModalSalvarSetup email={email} />

			<ModalEscolherPeça
				idsProdutosEscolhidos={idsProdutosEscolhidos}
				titulo={peçaDesejada}
				onClick={onClickProdutoSelecionado}
			/>

			<ToastContainer
				position="top-center"
				autoClose={3000}
				hideProgressBar={true}
				newestOnTop={false}
				closeOnClick
				theme="light"
			/>

			<main className="montagem page-container">
				<Location local="Montagem" />

				<div className="text-center mt-4">
					<h5>Monte seu Setup</h5>
					<p className="b2">
						Crie seu Setup, peça por peça, enquanto compara os melhores preços
						do mercado.
					</p>
				</div>

				<section className="secao-de-montagem">
					{Object.keys(produtosEscolhidos).map((peça, index) => {
						return (
							<div key={index} className="d-flex flex-column gap-2">
								<div className="d-flex align-items-center gap-2">
									<h6 style={{ whiteSpace: 'nowrap' }}>{peça}</h6>
									<hr style={{ width: "100%" }} />
								</div>

								{peça === "Fonte" && wattsRecomendado > 100 ? (<p className='s2 mb-1' style={{ color: '#A80A01' }}>{`Minimo Recomendado: ${wattsRecomendado} Watts.`}</p>) : (null)}

								<div className="d-flex justify-content-start">

									{produtosEscolhidos[peça] !== null ? (
										<div>
											<CardMontagem
												tipoBotao="Remover"
												{...produtosEscolhidos[peça]}
											/>
										</div>
									) : (
										<div
											data-bs-toggle="modal"
											data-bs-target="#modalEscolherPeça"
										>
											<BotaoAdicionar
												onClick={() => {
													setPeçaDesejada(peça);
												}}
											/>
										</div>
									)}

								</div>
							</div>
						);
					})}

					<div className="d-flex justify-content-between">
						<div className="text-start">
							<h6>Valor do Setup</h6>
							<p className="s1 negrito">{`R$ ${formataPreço(preçoTotal)}`}</p>
						</div>

						<div className="d-flex gap-3">

							{
								isLogged ? preçoTotal !== '0,00' ? (<div data-bs-toggle="modal" data-bs-target="#modalSalvarSetup">
									<img src={SaveIcon} alt="" style={{"cursor": "pointer"}}/>
								</div>) : <div onClick={() => toast("Seu Setup está vazio.")}>
									<img src={SaveIcon} alt="" style={{"cursor": "pointer"}}/>
								</div> : (<div onClick={onClickLevaProLogin}>
									<img src={SaveIcon} alt="" style={{"cursor": "pointer"}}/>
								</div>)
							}

							<div onClick={onClickCompartilharSetup}>
								<img src={ShareIcon} alt="" style={{"cursor": "pointer"}}/>
							</div>

						</div>

					</div>

				</section>
			</main>
		</>
	);
}

export default Montagem;
